// window.__ENV__ is written by the host app before its bundle loads (play-area's Docker entrypoint → /config.js).
// Returns undefined when absent (SSR/Next.js, local dev), so callers fall through to their build-time env.
export const getRuntimeEnv = (key: string): string | undefined => {
    if (typeof window === 'undefined') return undefined
    return (window as { __ENV__?: Record<string, string | undefined> }).__ENV__?.[key]
}
